<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="app">
        <transition :name="routerTransition" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import {getConnectedUser} from "@/api/api";
import {getValueCookie, deleteCookie} from "@/utils/cookie";
import AuthModule from './store/AuthModule';

export default {
    data() {
        return {
            routerTransition: themeConfig.routerTransition || 'none',
        };
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val);
        },
    },
    async created() {
        try {
            if (this.$auth) {
                await this.$auth.renewTokens();
            }
        } catch (e) {
            console.error(e);
        }
    },
    methods: {
        toggleClassInBody(className) {
            if (className == 'dark') {
                if (document.body.className.match('theme-semi-dark'))
                    document.body.classList.remove('theme-semi-dark');
                document.body.classList.add('theme-dark');
            } else if (className == 'semi-dark') {
                if (document.body.className.match('theme-dark'))
                    document.body.classList.remove('theme-dark');
                document.body.classList.add('theme-semi-dark');
            } else {
                if (document.body.className.match('theme-dark'))
                    document.body.classList.remove('theme-dark');
                if (document.body.className.match('theme-semi-dark'))
                    document.body.classList.remove('theme-semi-dark');
            }
        },
        handleWindowResize(event) {
            this.$store.dispatch(
                'updateWindowWidth',
                event.currentTarget.innerWidth
            );
        },
    },
    mounted() {
        this.toggleClassInBody(themeConfig.theme);
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleWindowResize);
        });
        this.$store.dispatch('updateWindowWidth', window.innerWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
};
</script>
